import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, EMPTY, throwError } from 'rxjs';
import { LoggingService } from '../services/logging.service';

export const noAccessInterceptor: HttpInterceptorFn = (req, next) => {
	const _loggingService = inject(LoggingService);
	const _router = inject(Router);
	return next(req).pipe(
		catchError((error) => {
			if (error?.status === 401 && error?.error?.error === 'User is not registered in SizingTools.') {
				_router.navigate(['/no-registered']);
				return EMPTY;
			} else if (error?.status === 403) {
				_router.navigate(['/no-permission']);
				return EMPTY;
			}
			else {
				const errorMsg = error?.error?.detail || error?.error?.message || error?.error || error?.message || 'An unexpected error occurred.';
          		_loggingService.errorMessage('Error', errorMsg);
			}

			return throwError(() => error);
		})
	);
};
